import { ObservableObject } from './patch';

export interface ObservableDataValueType {
  value: any;
  subscribe: Set<Function>;
}
// const ObservableStoreMap = new Map<string, BehaviorSubject<ObservableDataValueType>>();
export const observableStoreOp = new ObservableObject();
